// extracted by mini-css-extract-plugin
export default {"ContainerSwitch":"TrendSnapshotSwitch_ContainerSwitch__rx4bH","ActiveItem":"TrendSnapshotSwitch_ActiveItem__6yT1G","Item":"TrendSnapshotSwitch_Item__cHeQ4"};